import { render, staticRenderFns } from "./CreateSplashPage.vue?vue&type=template&id=b2b2fb2c&scoped=true"
import script from "./CreateSplashPage.vue?vue&type=script&lang=js"
export * from "./CreateSplashPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b2fb2c",
  null
  
)

export default component.exports